import { phoneBrandsProvider } from './phone-specs-provider'
import { AnswersProvider, AnswersProviders } from './interfaces'

export const getAnswerProviderByName = (name: AnswersProviders): AnswersProvider => {
  switch (name) {
    case AnswersProviders.PHONES_BRANDS:
      return phoneBrandsProvider
  }
}
